import { ReactNode, Ref, useCallback, useMemo } from 'react';
import { createPortal } from 'react-dom';
import * as htmlToImage from 'html-to-image';

interface ICapture {
  capture: () => Promise<Blob>;
};

interface PictureCapturingProps {
  children: ReactNode;
  captureRef: Ref<ICapture>;
  width?: number;
};

const PictureCapturingComponent = ({ children, captureRef, width = 1020 }: PictureCapturingProps) => {
  const container = useMemo(() => document.createElement('div'), []);

  const capture = useCallback(() => {
    return new Promise<Blob>((resolve, reject) => {
      const root = document.createElement('div');
      root.style.position = 'absolute';
      root.style.top = '-9999px';
      root.style.width = width + 'px';
      root.style.zIndex = '-1';
      root.appendChild(container);
      document.body.appendChild(root);

      setTimeout(() => {
        htmlToImage.toBlob(container).then((data: Blob | null) => {
          if (!data) {
            reject('Cannot generate image: data is empty.');
          } else {
            resolve(data);
          }
          document.body.removeChild(root);
        });
      }, 50);
    });
  }, [container, width]);

  if (captureRef) {
    if (typeof captureRef === 'function') {
      captureRef({capture});
    } else if (captureRef.current)
    {
      captureRef.current.capture = capture;
    }
  }

  return createPortal(children, container);
};

export default PictureCapturingComponent;
